var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',[(!_vm.hasTotalCount && !_vm.isDataLoading)?_c('SearchTagEmptyMessage',{attrs:{"page-type":_vm.pageType}}):_vm._l((_vm.bandList),function(sectionInfo,index){return _c('DynamicSectionLoader',{key:`${sectionInfo.title}_${_vm.$route.name}_${index}`,attrs:{"section-info":sectionInfo}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }